/** Список полей рулонов TODO: поменять */
const linesColumnDataGrid = [

  {
    dataField: 'qcId',
    caption: '№ СК ГП',
    dataType: 'string'
  },
  {
    dataField: 'soNum',
    caption: '№ сбытового заказа',
    dataType: 'string'
  },
  {
    dataField: 'soLineNum',
    caption: '№ позиции сбытового заказа',
    dataType: 'string'
  },
  {
    dataField: 'sapId',
    caption: 'Партия SAP',
    dataType: 'string'
  },
  {
    dataField: 'batchId',
    caption: 'Номер партии',
    dataType: 'string'
  },
  {
    dataField: 'pieceId',
    caption: 'Номер УЕ',
    dataType: 'string'
  },
  {
    dataField: 'pieceStatusName',
    caption: 'Статус УЕ',
    dataType: 'string'
  },
  {
    dataField: 'weight',
    caption: 'Количество',
    dataType: 'string'
  },
  {
    dataField: 'zdvlOrderNum',
    caption: '№ заказа на переработку',
    dataType: 'string'
  },
  {
    dataField: 'zdvlOrderLineNum',
    caption: '№ позиции заказа на переработку',
    dataType: 'string'
  },
  {
    dataField: 'thickness',
    caption: 'Толщина',
    dataType: 'number'
  },
  {
    dataField: 'width',
    caption: 'Ширина',
    dataType: 'number'
  },
  {
    dataField: 'materialText',
    caption: 'Материал',
    dataType: 'string'
  }
];

export default linesColumnDataGrid;
